/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export const SEARCH_WINDOW_SIZE = 10; /* This should be 10 but setting this value for smoke testing */
export const FOUND_SEARCH_RESULT = "FOUND_SEARCH_RESULT";

export const searchDirections = Object.freeze({
  PREVIOUS: 0,
  NEXT: 1
});

export const searchStates = Object.freeze({
  NO_ACTIVE_SEARCH: 0,
  SEARCHING_FOR_FIRST_SEARCH_RESULT: 1,
  SEARCHING_IN_BACKGROUND: 2,
  SEARCH_COMPLETE: 3
});

// #2680EB is used for SEARCH_RESULT_COLOR as mentioned in specs.
export const CURRENT_SEARCH_RESULT_COLOR = Object.freeze({
  red: 230,
  green: 80,
  blue: 0,
  alpha: 0.4
});

export const DEFAULT_SEARCH_RESULT_COLOR = Object.freeze({
  red: 230,
  green: 195,
  blue: 0,
  alpha: 0.35
});

export const LAST_SELECTED_SEARCH_RESULT_COLOR = Object.freeze({
  red: 255,
  green: 215,
  blue: 0,
  alpha: 0.5
});

export const pageSearchStates = Object.freeze({
  NOT_SEARCHED: 0,
  BEING_SEARCHED: 1,
  SEARCHED: 2
});

export const searchParentComponents = Object.freeze({
  HUD: 0,
  TOP_BAR: 1
});
